import actions from './actions';
import axios from 'axios';
import { API_PATH } from '../../../constants';

import { fetchObjects } from '../../utils/api-metadata-operations';

// fetch the archetype for a given report type
const fetchArchetype = (reportType, filters) => dispatch => {
  axios
    .get(`${API_PATH}/reporting/general_report/${reportType}/archetype`, { params: filters })
    .then(response => dispatch(actions.fetchArchetypeSuccess(response.data)));
};

const fetchData =
  ({ params, reportType }) =>
  async dispatch => {
    const cleanedParams = Object.entries(params).filter(([_key, value]) => value !== undefined);
    const queryString = new URLSearchParams(cleanedParams).toString();
    const url = `${API_PATH}/reporting/general_report/${reportType}/data?${queryString}`;

    if (params.file_type) {
      const backgroundJob = await axios.get(url);
      const id = backgroundJob.data.id;

      dispatch(actions.setDownloadProgress(5));

      while (true) {
        const status = await axios.get(`${API_PATH}/background_jobs/${id}`);
        await new Promise(resolve => setTimeout(resolve, 1000));
        dispatch(actions.setDownloadProgress(Math.max(5, status.data.progress)));
        if (status.data.status === 'completed' || status.data.status === 'failed') break;
      }
      const downloadUrl = `${API_PATH}/background_jobs/${id}/download`;

      // The call returns a file attachment. Instead of doing an axios
      // call, we redirect to the API call which will trigger the file download
      const link = document.createElement('a');
      link.href = downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      dispatch(actions.clearData());
      fetchObjects(url, {}, dispatch, actions, false, false, []);
    }
  };

export default {
  fetchArchetype,
  fetchData
};
